import API from 'services/api.js';
import { URL_SESSION_DETAIL, URL_GET_SESSION_CLOSE } from 'services/urls.js';
//import {
//actionResetSessionIds,
//actionFetchSessionIds,
//} from 'components/clientSessionSelect/sessionSelect/actions.js'
//import { dispatch } from 'd3';
//import { actionSetMessage, actionResetMessages } from 'components/messages/actions.js'
//import { formatInTimeZone } from 'components/utils/dateLib.js';
//import cookie from 'react-cookies'
import {
	//toDate,
	//zonedTimeToUtc,
	utcToZonedTime,
	//format
} from 'date-fns-tz';
//import addSeconds from 'date-fns/addSeconds';
//import addHours from 'date-fns/addHours';
//import differenceInHours from 'date-fns/differenceInHours'
//import differenceInSeconds from 'date-fns/differenceInSeconds'
// Sync Action

//const setSessionLoading = (status) =>{}//empty function

//export const actionFetchSessionDetail = (sessionId, clientId, showMessage, setLoading, setOffsetTzSec) => {
export const actionFetchSessionDetail = (
	sessionId,
	clientId,
	showMessage,
	setLoading
) => {
	const params = {
		params: { clientId: clientId, sessionId: sessionId },
		headers: {
			'x-opw-format': '',
		},
	};
	let resp = {};
	return API.get(URL_SESSION_DETAIL, params)
		.then((response) => {
			console.log('response actionFetchSessionDetail()', response);
			if (response.data !== undefined && response.data.length === 1) {
				resp = response.data[0];
			}
		})
		.catch((error) => {
			console.log('error actionFetchSessionDetail()', error);
			showMessage('Err fetching session detail data: ' + error);
		})
		.then(() => {
			setLoading(false);

			const sessionObjectStart = utcToZonedTime(
				resp.sessionStartUtc,
				resp.timezone
			);

			//offset UTC to local + local to SessionTz
			//const offset = (sessionObjectStart.getTimezoneOffset() * 60) + differenceInSeconds(new Date(resp.sessionStartUtc), sessionObjectStart)
			//setOffsetTzSec(offset);
			const sessionEndObj =
				resp.sessionEndUtc === null || resp.sessionEndUtc === undefined
					? null
					: utcToZonedTime(resp.sessionEndUtc, resp.timezone);
			const dateObj = {
				sessionStartObj: sessionObjectStart,
				sessionEndObj: sessionEndObj,
			};
			const modified = { ...resp, ...dateObj }; // merge data
			return modified;
			//return resp
		});
};

export const actionInsertSession = (
	sessionObj,
	setModified,
	showMessage,
	reloadSessionIds
) => {
	/**
	 * PUT = UPDATE
	 * POST = INSERT
	 */
	//let isUpdate = 'SessionID' in sessionObj;//check if key exists

	//dispatch(actionResetMessages())
	let rowsUpdated = 0;
	const config = {
		headers: {
			// Overwrite Axios's automatically set Content-Type
			'Content-Type': 'application/json',
		},
	};
	const json = JSON.stringify(sessionObj);
	return API.post(URL_SESSION_DETAIL, json, config)
		.then((response) => {
			try {
				rowsUpdated = response.data[0].updatedRows;
				if (rowsUpdated === 1) {
					reloadSessionIds();
					//dispatch(actionFetchSessionIds(sessionObj.Client, setSessionLoading))
					//dispatch(actionSetMessage(`New session added: ` + sessionObj.SessionName + ` (ID: ` + sessionObj.SessionId + `)`))
					//showMessage(`New session added: ` + sessionObj.SessionName + ` (ID: ` + sessionObj.SessionId + `)`);
					showMessage(`New session added: ` + sessionObj.SessionName);
				} else {
					//dispatch(actionSetMessage(response.data[0].msg));
					showMessage(response.data[0].msg);
					setModified(true);
				}
				return;
			} catch (error) {
				//dispatch(actionSetMessage('Err actionCloseSession: ' + error))
				showMessage('Err actionCloseSession: ' + error);
			}
		})
		.catch((error) => {
			console.log('ERR actionInsertSession: ', error);
			//dispatch(actionSetMessage(`ERR actionInsertSession: ${error}`))
			showMessage(`ERR actionInsertSession: ${error}`);
			//throw(error);
			// dispatch([
			// 	actionSetMessage(error + ', Cannot connect to server'),
			// 	actionResetLoading(),
			// 	])
		})
		.then(() => {
			//dispatch(actionResetSessionIds())
			//return resp
			return;
		});
};

export const actionUpdateSession = (
	sessionObj,
	clientId,
	setModified,
	showMessage,
	reloadSessionIds
) => {
	/**
	 * PUT = UPDATE
	 * POST = INSERT
	 */
	console.log('update sessionObj', sessionObj);
	return (dispatch) => {
		//dispatch(actionResetMessages())
		let rowsUpdated = 0;
		const config = {
			headers: {
				// Overwrite Axios's automatically set Content-Type
				'Content-Type': 'application/json',
			},
		};
		const json = JSON.stringify(sessionObj);
		return API.put(URL_SESSION_DETAIL, json, config)
			.then((response) => {
				console.log('update response', response);
				try {
					rowsUpdated = response.data[0].updatedRows;
					if (rowsUpdated === 1) {
						reloadSessionIds();
						//dispatch(actionFetchSessionIds(clientId, setSessionLoading))
						//dispatch(actionSetMessage(`Session '${sessionObj.SessionName}' (ID: ${sessionObj.SessionID}) saved.`))
						showMessage(
							`Session '${sessionObj.SessionName}' (ID: ${sessionObj.SessionID}) saved.`
						);
					} else {
						if (
							response.data[0].msg === null ||
							response.data[0].msg === undefined ||
							response.data[0].msg === ''
						) {
							//dispatch(actionSetMessage('Session update failed - you likely do not have admin'))
							showMessage(
								'Session update failed - you likely do not have admin'
							);
						} else {
							//dispatch(actionSetMessage(response.data[0].msg))
							showMessage(response.data[0].msg);
						}
						setModified(true);
					}
				} catch (error) {
					//dispatch(actionSetMessage('Err actionCloseSession: ' + error))
					showMessage('Err actionUpdateSession: ' + error);
				}
			})
			.catch((error) => {
				console.log('ERR actionUpdateSession: ', error);
				//dispatch(actionSetMessage(`ERR actionUpdateSession: ${error}`))
				showMessage(`ERR actionUpdateSession: ${error}`);
				//throw(error);
				// dispatch([
				// 	actionSetMessage(error + ', Cannot connect to server'),
				// 	actionResetLoading(),
				// 	])
			})
			.then(() => {
				//dispatch(actionResetSessionIds())
			});
	};
};

/**
 * returns the number of effected rows - should be 1
 * @param {*} sessionId
 * @param {*} sessionCloseLocal
 * @param {*} sessionCloseUtc
 * @param {*} showMessage
 * @param {*} setLoading
 */
export const actionCloseSession = async (
	sessionId,
	sessionCloseUtcStr,
	clientId,
	setLoading,
	reloadAfter,
	showMessage,
	reloadSessionIds
) => {
	const params = {
		params: {
			sessionId: sessionId,
			sessionCloseUtc: sessionCloseUtcStr,
		},
	};
	console.log('close session params', params);
	let rowsUpdated = 0;
	let msg = '';
	return await API.get(URL_GET_SESSION_CLOSE, params)
		.then((response) => {
			console.log('response actionCloseSession()', response);
			try {
				rowsUpdated = response.data[0].updatedRows;
				console.log('rowsUpdated', rowsUpdated);
				if (rowsUpdated === 1) {
					msg = `Closed session ${sessionId}.`;
				} else {
					if (
						response.data[0].msg === null ||
						response.data[0].msg === undefined ||
						response.data[0].msg === ''
					) {
						msg = 'Err4 Close session failed - you likely do not have admin';
					} else {
						//msg = `Cannot close session ${sessionId}. msg: ${response.data[0].msg}`;
						//:UNDO:
						msg = `Err3 Cannot close session ${sessionId}. msg: ${JSON.stringify(
							response
						)}`;
					}
				}
			} catch (error) {
				msg = 'Err1 actionCloseSession: ' + error;
			}
		})
		.catch((error) => {
			console.log('error actionCloseSession()', error);
			msg = 'Err2 actionCloseSession: ' + error;
		})
		.then(() => {
			setLoading(false);
			if (reloadAfter) {
				reloadSessionIds();
				//dispatch(actionFetchSessionIds(clientId, setSessionLoading))
			}
			//dispatch(actionSetMessage(msg))
			showMessage(msg);
			return;
		});
};
